import { Analytics } from '@yleisradio/areena-types';
import { ApplicationResolution } from '../applicationResolution';
import { Device, UtmParameters } from '../appTypings';
import { logger } from '../../common/logger';
import { trackState } from './analyticsTracker';
import {
  addUserId,
  getAppLabelsFromFeatures,
  getUserIdForYleSk,
} from './analytics-utils';
import { LoggedInUser } from '../../common/types';

export function sendPageloadAnalytics({
  analytics,
  applicationResolution,
  clearUtmParameters,
  device,
  loggedInUser,
  referer,
  updateReferer,
  utmParameters,
  version,
}: Parameters) {
  const comscore = analytics.pageload?.comscore;

  if (!comscore) {
    logger.debug(
      'Analytics pageload comscore missing. Skipping sending pageload analytics'
    );

    return;
  }

  const labelsFromFeatures = getAppLabelsFromFeatures({
    version,
    applicationResolution,
    device,
  });
  const pageloadId = analytics.app?.analytics?.yle_pageloadid;
  const profileAgeGroup =
    loggedInUser?.isSubAccount && loggedInUser.age !== undefined
      ? loggedInUser.age
      : null;

  trackState(
    addUserId(comscore, getUserIdForYleSk(loggedInUser)),
    {
      ...labelsFromFeatures,
      ...(profileAgeGroup ? { profile_age_group: profileAgeGroup } : {}),
      yle_referer: referer,
      yle_pageloadid: pageloadId,
    },
    utmParameters ? utmParameters : {}
  );

  clearUtmParameters();
  updateReferer(analytics.context?.comscore?.yle_referer);
}

export type Parameters = {
  analytics: Analytics;
  applicationResolution: ApplicationResolution;
  clearUtmParameters: () => void;
  device: Device | undefined;
  loggedInUser: LoggedInUser | null | undefined;
  referer: string | undefined;
  updateReferer: (referer: string | undefined) => void;
  utmParameters: UtmParameters;
  version: string;
};
